<script>
  export let sources;
</script>

<div class="locked-audio-container">
  <!-- svelte-ignore a11y-media-has-caption -->
  <audio class="locked-audio" controls>
    {#each Object.entries(sources) as [type, src]}
      <source {type} {src} />
    {/each}
  </audio>
</div>

<style>
  .locked-audio {
    max-width: 80%;
  }
</style>
